import { ReactNode, ReactElement } from "react";
import Head from "next/head";

import { FormConfig } from "@evergiving/common/dist/es2015/form";
import { Favicons } from "@/lib/build/generatedFavicons";
import { CommonHead } from "@/lib/build/CommonHead";
import { FormContext } from "@/lib/build/FormContext";

export interface ServerSideError {
  statusCode: number;
  message: string;
}

export type StaticPageProps = {
  formConfig: FormConfig;
  basePath: string;
  children: (formConfig: FormConfig) => ReactNode;
};

export function StaticPage(props: StaticPageProps): ReactElement {
  const { children, formConfig, basePath } = props;
  return (
    <>
      <Head>
        <Favicons />
      </Head>
      <CommonHead formConfig={formConfig} />
      <FormContext.Provider value={{ basePath }}>
        {children(formConfig)}
      </FormContext.Provider>
    </>
  );
}
